import { Radio } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { changeTheme, selectTheme, ThemeType } from "../../../../redux/theme/themeSlice";
import styles from "./Theme.module.scss";
import { globalConfig, ThemeKey } from '../../../../config/config';

const THEME_LIST = [
    {
        value: "base",
    },
    {
        value: "eye-protect",
    },
    {
        value: "blue",
    },
    {
        value: "red",
    },
    {
        value: "green",
    },
    {
        value: "purple",
    },
    {
        value: "orange",
    },
    {
        value: "violet",
    },
]

const style: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '36px',
    width: '100%',
};
export const Theme = () => {
    const dispatch = useDispatch()
    const theme = useSelector(selectTheme)
    const onChangeTheme = (value: string) => {
        dispatch(changeTheme(value as ThemeType))
        globalConfig.setItem(ThemeKey, value)
    }

    return (
        <div className={styles.themeSetting} >
            <div className={styles.themeSettingContent}>
                <Radio.Group
                    onChange={(e) => onChangeTheme(e.target.value)}
                    value={theme}
                    style={style}
                    options={
                        THEME_LIST.map((item) => {
                            return {
                                value: item.value,
                                label: (
                                    <div className={styles.themeItemText}>{item.value}</div>
                                )
                            }
                        })
                    }
                />
            </div>
        </div>
    );
};
